var text_field_default = {
  "root": "fCRBM",
  "text": "HUr0D",
  "input": "_4iYhH",
  "small": "jRbxw",
  "medium": "dquj-",
  "large": "k6E-U",
  "webview": "_3qtRL",
  "endAdornment": "aPDK5",
  "shown": "edjYf",
  "value": "Vu2-j",
  "spinner": "mRD9L",
  "spin": "Jsln5"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
